<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
  >
    <BaseInput
      :label="
        localStorage.translations.pages['setting-work_type_category']['dialog-add_edit-labels'][
          'tipy-proekta'
        ]
      "
      type="select"
      v-model="projectTypes"
      :items="workProjectTypeAll"
      :placeholder="
        localStorage.translations.pages['setting-work_type_category']['dialog-add_edit-labels'][
          'tipy-proekta'
        ]
      "
      prepend-inner-icon="mdi-format-list-text"
      item-text="name"
      item-value="id"
      multiple
      chips
      append-icon="fas fa-angle-down"
    />
    <BaseInput
      :label="
        localStorage.translations.pages['setting-work_type_category']['dialog-add_edit-labels'][
          'nazvanie'
        ]
      "
      v-model="name"
      prepend-inner-icon="mdi-format-list-bulleted-type"
      :rules="['required', 'max100']"
      :placeholder="
        localStorage.translations.pages['setting-work_type_category']['dialog-add_edit-labels'][
          'nazvanie'
        ]
      "
    />
  </TemplateModal>
</template>

<script>
import BaseInput from 'components/base/BaseInput'
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'WorkTypeCategoryModal',
  components: { BaseInput },
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    create: Boolean
  },
  data: () => ({
    name: '',
    projectTypes: [],
  }),
  computed: {
    ...mapGetters('workTypeCategory', ['workTypeCategoryData', 'workTypeCategoryGridAll']),
    ...mapGetters('workProjectType', ['workProjectTypeAll']),
    t() {
      return this.localStorage.translations.pages['setting-work_type_category']
    },
    text() {
      return {
        button: {
          open: this.t['dialog-add_edit-buttons']['dobavit'],
        },
        title: {
          create: this.t['dialog-add_edit']['sozdanie-kategorii-rabot'],
          edit: this.t['dialog-add_edit']['redaktirovanie-kategorii-rabot'],
        },
      }
    },
  },
  watch: {
    workTypeCategoryData() {
      this.name = this.workTypeCategoryData.name
      this.projectTypes = this.workTypeCategoryData.project_types.map((i) => i.id)
    },
  },
  methods: {
    ...mapActions('workTypeCategory', [
      'onWorkTypeCategoryData',
      'onWorkTypeCategoryCreate',
      'onWorkTypeCategoryGrid',
      'onWorkTypeCategoryUpdate',
      'onWorkTypeCategoryGridAll',
    ]),
    ...mapActions('workProjectType', ['onWorkProjectTypeAll']),
    onOpen() {
      this.onWorkProjectTypeAll()
      if (this.create) {
        this.name = ''
        this.projectTypes = []
      } else {
        this.onWorkTypeCategoryData(this.id)
        this.onWorkTypeCategoryGridAll()
      }
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    onSave() {
      if (this.create) {
        let data = {
          name: this.name,
          project_types: this.projectTypes,
        }
        this.onWorkTypeCategoryCreate(data)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-dobavlen'],
                IsError: false,
              },

              { root: true },
            )
            this.onWorkTypeCategoryGrid({
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            if (err.response.data.name[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                      ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      } else {
        let data = {
          id: this.workTypeCategoryData.id,
          name: this.name,
          project_types: this.projectTypes,
        }
        this.onWorkTypeCategoryUpdate(data)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                    ],
                IsError: false,
              },

              { root: true },
            )
            this.onWorkTypeCategoryGrid({
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            if (err.response.data.name[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                      ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
    },
  },
}
</script>
